import { gql } from "@apollo/client"; import { useLazyQuery } from "@apollo/client/react";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import SearchIcon from '@mui/icons-material/Search';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { useForm } from '../../../components/hooks/useForm';
import { GetDescripcionMensaje } from '../../../helpers/tools';
import { TextInput } from '../../../components/textInput/TextInput';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';

import './seccionUsuario.scss';
import '../../../assets/css/App.css';
const QGetUsuariosByApp = gql`
    query QGetUsuarios($usuario: String!, $clave: String!){
        usuariosByApp(model: { usuario: $usuario, clave: $clave })
            {
                success,
                error,
                valorEsperado {
                    id,
                    usuario,
                    nombre,
                    apellido,
                    email,
                    idTipoDocumento,
                    tipoDocumento,
                    numeroDocumento,
                    activo,
                    fechaNacimiento,
                    idTipoUsuario,
                    tipoUsuario,
                    telefono,
                    sexo
                }
            }
    }`;

export default function SeccionUsuario({ usuarioAuth, setUsuarioAuth }) {

  const [openDlgAuth, setOpenDlgAuth] = useState(false);
  const [openDlgPass, setOpenDlgPass] = useState(false);
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  const [usuariosAuth, setUsuariosAuth] = useState('');
  const [dataOriginalAuth, setDataOriginalAuth] = useState('');
  const [usuarioId, setUsuarioId] = useState(0);

  const txtBuscarAuth = useRef(null);

  // campos
  const fldUsuario = useRef(null);
  const fldNombre = useRef(null);
  const fldApellido = useRef(null);
  const fldTipoDocumento = useRef(null);
  const fldNumeroDocumento = useRef(null);
  const fldSexo = useRef(null);
  const fldFechaNacimiento = useRef(null);
  const fldEmail = useRef(null);
  const fldTelefono = useRef(null);
  const fldTipoUsuario = useRef(null);

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  const [state, setState] = useState({
    ShowPass: false
  });
  const handleClickShowPassword = () => {
    setState({
      ...state,
      ShowPass: !state.ShowPass
    });
  };

  const [formPassValues, formPassHandle, setFormPassValues] = useForm({
    password: ''
  });

  const [getUsuariosByApp, { loading: loadingUserAuth, error: usuariosError, data: dataAuth }] = useLazyQuery(QGetUsuariosByApp, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!dataAuth) return;
    if (dataAuth.usuariosByApp.success) {
      setOpenDlgPass(false);
      setOpenDlgAuth(true);

      setUsuariosAuth(dataAuth.usuariosByApp.valorEsperado);
      setDataOriginalAuth(dataAuth.usuariosByApp.valorEsperado);
    } else {
      let descripcionError = GetDescripcionMensaje(dataAuth.usuariosByApp.error);
      if (isNaN(descripcionError)) {
        let mensaje = `${dataAuth.usuariosByApp.error} - ${descripcionError}`;
        toast.error(mensaje);
      } else if (dataAuth.usuariosByApp.error === 'ERRORDB' || parseInt(dataAuth.usuariosByApp.error, 10) > 0) {
        setMensajeError(dataAuth.usuariosByApp.error);
      } else {
        setMensajeError("ERRORDB");
      }
    }
  }, [dataAuth]);

  useEffect(() => {
    if (!usuariosError) return;
    setMensajeError("ERRORDB");
  }, [usuariosError]);

  const buscarUsuarioAuth = () => {
    setOpenDlgPass(true);
  };

  const handleCloseDlgAuth = () => {
    setOpenDlgAuth(false);
    setFormPassValues({
      ...formPassValues,
      password: ''
    });
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleAceptar();
    }
  };

  const handleClick = () => {
    const usuario = sessionStorage.getItem('usuario');
    let result = getUsuariosByApp({ variables: { usuario: usuario, clave: formPassValues.password } });
  };

  const handleAceptar = () => {
    if (isFormValid()) {
      handleClick();
    }
  };

  const isFormValid = () => {
    if (formPassValues.password.length === 0) {
      toast.error("Debe ingresar su contraseña");
      return false;
    }

    return true;
  };


  const handleSearchAuth = () => {
    // si se ingresó texto a buscar (al menos 3 caracteres) --> filtro, sino retorno todos los registros
    // originales consultados
    if (txtBuscarAuth.current.value != "") {
      if (txtBuscarAuth.current.value.length >= 3) {
        setUsuariosAuth(dataOriginalAuth.filter((dataOriginalAuth) => {
          const usuarioBuscar = dataOriginalAuth.usuario.toLowerCase();
          const nombreBuscar = dataOriginalAuth.nombre.toLowerCase();
          const apellidoBuscar = dataOriginalAuth.apellido.toLowerCase();
          const emailBuscar = dataOriginalAuth.email.toLowerCase();

          const inputBuscar = txtBuscarAuth.current.value.toLowerCase();
          return (
            usuarioBuscar.includes(inputBuscar) ||
            nombreBuscar.includes(inputBuscar) ||
            apellidoBuscar.includes(inputBuscar) ||
            emailBuscar.includes(inputBuscar));

        }
        ));
      }
    } else {
      const usuario = sessionStorage.getItem('usuario');
      getUsuariosByApp({ variables: { usuario: usuario, clave: formPassValues.password } });
    }
  };

  const handleCleanAuth = () => {
    txtBuscarAuth.current.value = "";
    handleSearchAuth();
    txtBuscarAuth.current.focus();
  };

  const onCloseDlgPass = () => {
    setOpenDlgPass(false);
  };

  // Click sobre fila de la grilla de búsqueda de usuarios Auth
  const handleRowClick = (params) => {
    var nacimiento = moment(params.row.fechaNacimiento, "MM/DD/YYYY").format("DD/MM/YYYY");

    setUsuarioAuth((prevState) => {
      return {
        ...prevState,
        Id: params.row.id,
        Apellido: params.row.apellido,
        Nombre: params.row.nombre,
        Usuario: params.row.usuario,
        Email: params.row.email,
        TipoDocumento: params.row.tipoDocumento,
        IdTipoDocumento: params.row.idTipoDocumento,
        NumeroDocumento: params.row.numeroDocumento,
        Sexo: params.row.sexo,
        IdTipoUsuario: params.row.idTipoUsuario,
        TipoUsuario: params.row.tipoUsuario,
        Telefono: params.row.telefono,
        FechaNacimiento: nacimiento,
        IdUsuario: usuarioId
      };
    });

    // setUsuarioAuthStep(usuarioAuth);

    handleCloseDlgAuth();
  };

  const initialColumns = [
    { field: 'id', headerName: 'Id' },
    { field: 'usuario', headerName: 'Usuario' },
    { field: 'apellido', headerName: 'Apellido' },
    { field: 'nombre', headerName: 'Nombre' },
    { field: 'email', headerName: 'Email', flex: 0.4 }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);

  return (
    <>
      <CustomButton style={{ marginBottom: 20 }} onClick={buscarUsuarioAuth}>
        Buscar usuario
      </CustomButton>
      <Grid
        container
        rowSpacing={2}
        columns={{ xs: 3, md: 12 }}
        columnSpacing={3}>

        <Grid size={{ xs: 12, sm: 3, md: 3 }}>
          <TextField
            className="input-250"
            disabled="true"
            inputRef={fldUsuario}
            label="Usuario"
            name="Usuario"
            required
            size="small"
            type="text"
            value={usuarioAuth.Usuario}
            variant="outlined"
            fullWidth />

        </Grid>
        <Grid size={{ xs: 12, sm: 3, md: 3 }}>
          <TextField
            className="input-250"
            disabled="true"
            inputRef={fldNombre}
            label="Nombre"
            name="Nombre"
            required
            size="small"
            type="text"
            value={usuarioAuth.Nombre}
            variant="outlined"
            fullWidth />

        </Grid>
        <Grid size={{ xs: 12, sm: 3, md: 3 }}>
          <TextField
            className="input-250"
            disabled="true"
            inputRef={fldApellido}
            label="Apellido"
            name="Apellido"
            required
            size="small"
            type="text"
            value={usuarioAuth.Apellido}
            variant="outlined"
            fullWidth />

        </Grid>
        <Grid size={{ xs: 12, sm: 3, md: 3 }}>
          <TextField
            className="input-250"
            disabled="true"
            inputRef={fldTipoDocumento}
            label="Tipo Documento"
            name="TipoDocumento"
            required
            size="small"
            type="text"
            value={usuarioAuth.TipoDocumento}
            variant="outlined"
            fullWidth />

        </Grid>
        <Grid size={{ xs: 12, sm: 3, md: 3 }}>
          <TextField
            className="input-250"
            disabled="true"
            inputRef={fldNumeroDocumento}
            label="Número Documento"
            name="NumeroDocumento"
            required
            size="small"
            type="text"
            value={usuarioAuth.NumeroDocumento}
            variant="outlined"
            fullWidth />

        </Grid>
        <Grid size={{ xs: 12, sm: 3, md: 3 }}>
          <TextField
            className="input-250"
            disabled="true"
            inputRef={fldSexo}
            label="Sexo"
            name="Sexo"
            required
            size="small"
            type="text"
            value={usuarioAuth.Sexo}
            variant="outlined"
            fullWidth />

        </Grid>
        <Grid size={{ xs: 12, sm: 3, md: 3 }}>
          <TextField
            className="input-250"
            disabled="true"
            inputRef={fldFechaNacimiento}
            label="Fecha Nacimiento"
            name="FechaNacimiento"
            required
            size="small"
            type="text"
            value={usuarioAuth.FechaNacimiento}
            variant="outlined"
            fullWidth />

        </Grid>
        <Grid size={{ xs: 12, sm: 3, md: 3 }}>
          <TextField
            className="input-250"
            disabled="true"
            inputRef={fldTipoUsuario}
            label="Tipo Usuario"
            name="TipoUsuario"
            required
            size="small"
            type="text"
            value={usuarioAuth.TipoUsuario}
            variant="outlined"
            fullWidth />

        </Grid>
        <Grid size={{ xs: 12, sm: 3, md: 3 }}>
          <TextField
            className="input-250"
            disabled="true"
            inputRef={fldTelefono}
            label="Teléfono"
            name="Telefono"
            required
            size="small"
            type="text"
            value={usuarioAuth.Telefono}
            variant="outlined"
            fullWidth />

        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
          <TextField
            className="input-300"
            disabled="true"
            inputRef={fldEmail}
            label="Email"
            name="Email"
            required
            size="small"
            type="text"
            value={usuarioAuth.Email}
            variant="outlined"
            fullWidth />

        </Grid>
      </Grid>

      <CustomDialog
        maxWidth="lg"
        fullWidth={true}
        open={openDlgAuth}
        title={'Búsqueda de Usuarios Auth'}
        onCancel={handleCloseDlgAuth}>

        <div style={{ display: 'flex', width: '100%' }}>
          <div style={{ display: 'flex', width: '100%' }}>
            <TextField
              className="input-300"
              label="Filtrar usuarios"
              style={{ marginBottom: 20 }}
              name="txtBuscarAuth"
              size="small"
              type="text"
              variant="outlined"
              inputRef={txtBuscarAuth}
              onKeyUp={handleSearchAuth}
              InputProps={{
                endAdornment:
                  <InputAdornment position="end">
                    <SearchIcon
                      onClick={handleSearchAuth}
                      sx={{ cursor: 'pointer' }} />

                    <ClearIcon
                      onClick={handleCleanAuth}
                      sx={{ cursor: 'pointer' }} />

                  </InputAdornment>

              }} />

          </div>
        </div>
        <DataGridGenerico
          columns={columns}
          rows={usuariosAuth}
          toolbar={false}
          onRowClick={handleRowClick} />

      </CustomDialog>

      <CustomDialog
        maxWidth="sm"
        fullWidth={true}
        open={openDlgPass}
        title={'Ingrese su contraseña'}
        onCancel={onCloseDlgPass}
        onAccept={handleAceptar}
        acceptLoading={loadingUserAuth}>

        <div className='dialog-content'>
          <TextInput
            name='password'
            label='Contraseña'
            value={formPassValues.password}
            onChange={formPassHandle}
            onKeyDown={handleKeyDown}
            type={state.ShowPass ? 'text' : 'password'}
            customProps={{
              endAdornment:
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    edge="end">

                    {state.ShowPass ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>

            }} />

        </div>
      </CustomDialog>
    </>);

};